// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
const stage = String(import.meta.env.VITE_STAGE || import.meta.env.MODE || '')
  .trim()
  .toLowerCase()

const restrictedStages = new Set(['stg', 'prd', 'production'])

export const isStgOrPrd = (): boolean => restrictedStages.has(stage)
